module.exports = __webpack_public_path__ + "img/qy_27.96f00535.png";